import { IDropdownOption } from 'office-ui-fabric-react';
import { ITicket } from '../../model';

export const comparePriorityAndTime = (a: ITicket, b: ITicket) => {
    if (a.priorityLevel < b.priorityLevel) {
        return 1;
    } else if (a.priorityLevel > b.priorityLevel) {
        return -1;
    } else {
        if (a.queuePriorityLevel < b.queuePriorityLevel) {
            return 1;
        } else if (a.queuePriorityLevel > b.queuePriorityLevel) {
            return -1;
        } else {
            var date1 = Date.parse(a.modifiedAt);
            var date2 = Date.parse(b.modifiedAt);
            if (date1 > date2 || date1 === date2) {
                return 1;
            } else {
                return -1;
            }
        }
    }
};

export const compareByVisitTime = (a: ITicket, b: ITicket) => {
    if (!a.visitDate && !b.visitDate) {
        return 0;
    } else if (!b.visitDate) {
        return 1;
    } else if (!a.visitDate) {
        return -1;
    } else {
        var date1 = Date.parse(a.visitDate);
        var date2 = Date.parse(b.visitDate);
        if (date1 > date2 || date1 === date2) {
            return 1;
        } else {
            return -1;
        }
    }
};

export const filterTicketByDropdown = (ticket: ITicket, filterOptionKeys: IDropdownOption[]) => {
    const selectedFilters = filterOptionKeys.filter(e => e.selected);

    if (selectedFilters.some(x => x.key === '-1')) {
        return ticket;
    } 
    else if (ticket.serviceId === null && selectedFilters.some(x => x.key === '0')) {
        return ticket;
    } 
    else if (ticket.serviceId !== null && selectedFilters.some(x => x.key === ticket.serviceId?.toString())) {
        return ticket;
    } 
};

export const filterTicketsByTerm = (x: ITicket, filterText: string) => {
    if (
        x.number.toLowerCase().includes(filterText.toLowerCase()) ||
        x.patientFirstName.toLowerCase().includes(filterText.toLowerCase()) ||
        x.patientLastName.toLowerCase().includes(filterText.toLowerCase()) ||
        x.serviceName?.toLowerCase().includes(filterText.toLowerCase())
    ) {
        return true;
    }
    return false;
};
